import request from "@/utils/request";

export default function page(current=1,size=10,params) {
    return request({
        url: `/news/agency/page/merchantNews/`+current+`/`+size,
        method: 'get',
        params
    })
}
